import trackingEventDictionary from "@core/dictionary/tracking-event";
import { categoryType, filterTypeDictionary as filterType } from "@core/global/global-country-dictionary";
import { getApiUrl } from "@utils/baseUrl";

export const companyCategoryData = [
  {
    id: "trade_country",
    keyTop: "key",
    key: "doc_count",
    key2: "top_hscodes",
    key2item: "key",
    key2Alt: "top_ports",
    key2itemAlt: "port_name",
    key1: "trading_partner",
    key1item: "company_name",
    value: "Countries",
    eventEnum: "tradeCountries",
    countEnum: "trade_country_count",
    iconEnum: "flag",
    isExpandable: true,
    headingText: "Country of",
    isSecondDiv: false,
  },
  {
    id: "port",
    keyTop: "",
    key: "",
    key1: "doc_count",
    key2: "opp_top_ports",
    key2Alt: "opp_top_ports",
    key1secondDiv: "port_name",
    key2secondDiv: "country",
    key3secondDiv: "countryCode",
    key2Item: "port_name",
    value: "Ports",
    eventEnum: "tradePorts",
    countEnum: "trade_port_count",
    iconEnum: "anchor",
    headingText: "Port Shipped from",
    countEnum2: "top_ports_count",
    isSecondDiv: true,
    isExpandable: true,
  },
  {
    id: "location",
    keyTop: false,
    key: "address",
    key1: "doc_count",
    key2: "doc_count",
    key2Alt: "doc_count",
    value: "Locations",
    eventEnum: "locations",
    countEnum: "location_count",
    iconEnum: "distance",
    headingText: "",
    isExpandable: false,
    isSecondDiv: false,
  },
];

export const cachingPanelData = {
  importers: "importers",
  exporters: "exporters",
  logistic_partners: "logistic_partners",
  corporate_heirarchy: "corporate_heirarchy",
  due_diligence_reports: "due_diligence_reports",
};

export const panelData = [
  {
    id: "importers",
    text: "Trade as Buyer",
    redirectionEnum: "I",
    countEnum: "importers",
    tabs: [
      // {
      //   id: "overview",
      //   text: "Trade Overview",
      //   isExcludeFilter: true,
      // },
      {
        id: "ai_summary",
        text: "AI Summary",
        redirectionEnum: "ai_summary",
        isExcludeFilter: true,
        iconBeforeUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1761888982/Sanctions/sparkle_3_hv5h4n.svg",
        iconAfterUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1768541879/intel/misc/BETA_ICON_hqpp9y.svg",
      },
      {
        id: "trade_country",
        text: "Countries",
        countEnum: "trade_country_count",
        isExcludeFilter: true,
      },
      {
        id: "port",
        text: "Ports",
        countEnum: "trade_port_count",
        isExcludeFilter: true,
      },
      {
        id: "location",
        text: "Locations",
        countEnum: "location_count",
        isExcludeFilter: true,
      },
      {
        id: "trading_partner",
        text: "Trading Partners",
        countEnum: "tradingPartnerCount",
        redirectionEnum: "tradingPartners",
      },
      {
        id: "hs_code",
        text: "HS Codes",
        countEnum: "hsCodeCount",
        redirectionEnum: "hscodes",
      },
    ],
    key: "isBuyer",
  },
  {
    id: "exporters",
    text: "Trade as Supplier",
    redirectionEnum: "E",
    countEnum: "exporters",
    key: "isSupplier",
    tabs: [
      // {
      //   id: "overview",
      //   text: "Trade Overview",
      //   isExcludeFilter: true,
      // },
      {
        id: "ai_summary",
        text: "AI Summary",
        redirectionEnum: "ai_summary",
        isExcludeFilter: true,
        iconBeforeUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1761888982/Sanctions/sparkle_3_hv5h4n.svg",
        iconAfterUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1768541879/intel/misc/BETA_ICON_hqpp9y.svg",
      },
      {
        id: "trade_country",
        text: "Countries",
        countEnum: "trade_country_count",
        isExcludeFilter: true,
      },
      {
        id: "port",
        text: "Ports",
        countEnum: "trade_port_count",
        isExcludeFilter: true,
      },
      {
        id: "location",
        text: "Locations",
        countEnum: "location_count",
        isExcludeFilter: true,
      },
      {
        id: "trading_partner",
        text: "Trading Partners",
        countEnum: "tradingPartnerCount",
        redirectionEnum: "tradingPartners",
      },
      {
        id: "hs_code",
        text: "HS Codes",
        countEnum: "hsCodeCount",
        redirectionEnum: "hscodes",
      },
    ],
  },
  {
    id: "logistic_partners",
    text: "Logistics Partners",
    redirectionEnum: "logisticPartners",
    countEnum: "logisticPartners",
    key: "is_logistic_data",
    tabs: [
      {
        id: "vocc",
        text: "VOCCs",
        countEnum: "voccCount",
        redirectionEnum: "vocc",
      },
      {
        id: "nvocc",
        text: "NVOCCs",
        countEnum: "nvoccCount",
        redirectionEnum: "nvocc",
      },
      {
        id: "freight_forwarder",
        text: "Freight Forwarders",
        countEnum: "freightForwarderCount",
        redirectionEnum: "freightForwarder",
      },
    ],
  },
  {
    id: "corporate_heirarchy",
    text: "Corporate Hierarchy",
    redirectionEnum: "corporate Heirarchy",
    countEnum: "corporateHeirarchy",
    key: "is_hierarchial_data",
    upgradeIconEnum: "corporate_heirarchy",
  },
  {
    id: "due_diligence_reports",
    text: "Due Diligence Reports",
    redirectionEnum: "due diligence reports",
    countEnum: "due_diligence_reports",
    key: "is_due_dilligence",
    upgradeIconEnum: "due_diligence_reports",
  },
  {
    id: "contact_details",
    text: "Contact Details",
    redirectionEnum: "contactDetails",
    countEnum: "contactDetails",
  },
];

export const companyTabs = [
  {
    id: "trade_country",
    text: "Countries",
    countEnum: "trade_country_count",
    isExcludeFilter: true,
  },
  {
    id: "port",
    text: "Ports",
    countEnum: "trade_port_count",
    isExcludeFilter: true,
  },
  {
    id: "location",
    text: "Locations",
    countEnum: "location_count",
    isExcludeFilter: true,
  },
  {
    id: "ai_summary",
    text: "AI Summary",
    redirectionEnum: "ai_summary",
    isExcludeFilter: true,
  },
  {
    id: "overview",
    text: "Trade Overview",
    isExcludeFilter: true,
  },
  {
    id: "trading_partner",
    text: "Trading Partners",
    countEnum: "tradingPartnerCount",
    redirectionEnum: "tradingPartners",
  },
  {
    id: "hs_code",
    text: "HS Codes",
    countEnum: "hsCodeCount",
    redirectionEnum: "hscodes",
  },
  {
    id: "freight_forwarder",
    text: "Freight Forwarders",
    countEnum: "freightForwarderCount",
    redirectionEnum: "freightForwarder",
  },
  {
    id: "vocc",
    text: "VOCC",
    countEnum: "voccCount",
    redirectionEnum: "vocc",
  },
  {
    id: "nvocc",
    text: "NVOCC",
    countEnum: "nvoccCount",
    redirectionEnum: "nvocc",
  },
];

export const companyEvents = {
  freight_forwarder: {
    tab: trackingEventDictionary.tradeFrieghtForwardersTab,
    tabDownload: trackingEventDictionary.tradeFrieghtForwardersTabDownload,
    profileClick: trackingEventDictionary.tradeFrieghtForwardersTabFrieghtForwardersProfileClick,
    viewShipments: trackingEventDictionary.tradefrieghtForwardersTabfrieghtForwardersProfileViewShipments,
  },
  vocc: {
    tab: trackingEventDictionary.tradeVoccTab,
    tabDownload: trackingEventDictionary.tradeVoccTabDownload,
    profileClick: trackingEventDictionary.tradeVoccTabVoccProfileClick,
    viewShipments: trackingEventDictionary.tradeVoccTabVoccProfileViewShipments,
  },
  nvocc: {
    tab: trackingEventDictionary.tradeNvoccTab,
    tabDownload: trackingEventDictionary.tradeNvoccTabDownload,
    profileClick: trackingEventDictionary.tradeNvoccTabNvoccProfileClick,
    viewShipments: trackingEventDictionary.tradeNvoccTabNvoccProfileViewShipments,
  },
  importers: {
    tab: trackingEventDictionary.tradeImportersTab,
    tabDownload: trackingEventDictionary.tradeImportersTabDownload,
    profileClick: trackingEventDictionary.tradeImportersTabImportersProfileClick,
    viewShipments: trackingEventDictionary.tradeImportersTabImportersProfileViewShipments,
  },
  exporters: {
    tab: trackingEventDictionary.tradeExportersTab,
    tabDownload: trackingEventDictionary.tradeExportersTabDownload,
    profileClick: trackingEventDictionary.tradeExportersTabExportersProfileClick,
    viewShipments: trackingEventDictionary.tradeExportersTabExportersProfileViewShipments,
  },
  overview: {
    tab: trackingEventDictionary.tradeOverViewTab,
    tradeLanes: trackingEventDictionary.tradeOverviewTabTradeLanes,
    tradeCountries: trackingEventDictionary.tradeOverviewTabTradeCountries,
    tradePorts: trackingEventDictionary.tradeOverviewTabTradePorts,
    locations: trackingEventDictionary.tradeOverviewTabLocations,
    portOfLading: trackingEventDictionary.tradeOverviewTabAsPortOfLading,
    portOfUnLading: trackingEventDictionary.tradeOverviewTabAsPortOfUnLading,
    importers: trackingEventDictionary.tradeOverviewTabAsImporters,
    exporters: trackingEventDictionary.tradeOverviewTabAsExporters,
    logisticPartners: trackingEventDictionary.tradeOverviewTabAsLogisticPartners,
    corporateHeirarchy: trackingEventDictionary.tradeOverviewTabAsCorporateHeirarchy,
    contactDetails: trackingEventDictionary.tradeOverviewTabAsContactDetails,
  },
  landing: trackingEventDictionary.landing,
  viewShipments: trackingEventDictionary.viewShipments,
};

export const portProfileAPIEndPoints = {
  getProfileHeaderDetails: getApiUrl("profileDetails"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  getMapData: getApiUrl("profileMapData"),
  getShipperDetails: getApiUrl("profileMapData"),
};

const logisticsProfileAPIEndPoints = {
  getProfileHeaderDetails: getApiUrl("profileDetails"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  getMapData: getApiUrl("profileMapData"),
  getShipperDetails: getApiUrl("profileMapData"),
};

export const profileTypeEndPoint = {
  ports: portProfileAPIEndPoints,
  logistics: logisticsProfileAPIEndPoints,
  getShipmentDistribution: getApiUrl("profileSummaryData"),
  getCompanySlug: getApiUrl("companyProfiles/getSlug"),
  getInTouch: getApiUrl("notifySales"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  downloadProfileExcel: getApiUrl("download_profiles_excel_data"),
};

export const profileTypeEnum = {
  ports: "port",
  logistics: "logistics",
  company: "company",
};

export const getProfileTypeEnum = {
  portOfLading: "port",
  portOfUnlading: "port",
  vocc: "logistics",
  nvocc: "logistics",
  freightForwarder: "logistics",
};

export const eventNameEnum = {
  ports: "Port_profile_page_",
  logistics: "logisitics_profile_page_",
};

export const companyType = {
  isBuyer: "I",
  isSupplier: "E",
};

export const shipperFacilityFilter = { heading: "Filter by Shipper Locations Name", categoryName: categoryType.shipperDetails, eventKey: "29", key: "shipperFacility", type: filterType.normalFilter, label: "Shipper Locations", viewAllPlaceHolder: "Search in Shipper Locations Filter", emptyFilterText: "", searchFilterString: "", showNew: true };
export const consigneeFacilityFilter = { heading: "Filter by Consignee Locations Name", categoryName: categoryType.consigneeDetails, eventKey: "30", key: "consigneeFacility", type: filterType.normalFilter, label: "Consignee Locations", viewAllPlaceHolder: "Search in Consignee Locations Filter", emptyFilterText: "", searchFilterString: "", showNew: true };
export const tradingPartnerRangeConst = { from: 1, to: 100 };

export const profileDetailsInfo = {
  naics_code: "NAICS Code",
  sic_code: "SIC Code",
  lei_code: "LEI Code",
  tickers: "Stock Ticker",
  revenue: "Revenue",
  scac_code: "SCAC Code",
  ruc: "RUC",
  websites: "Website",
};

export const isBuyerSupplier = {
  isBuyer: "isBuyer",
  isSupplier: "isSupplier",
};
